import { InjectionToken } from "@angular/core";


export const CWT_LANGUAGE_CONFIG = new InjectionToken<CwtLanguageConfig>('cwt-language-config');

export interface CwtLanguageConfig {
    appName: string;
    translationFilePath: string;
    storageKey: string;
    locales: string[];
    default: string;
}